import { AuthServiceImpl } from '@/services/auth/AuthServiceImpl';
import { AdministratorsServiceImpl } from '@/services/adminstrators/AdminstratorsServiceImpl';
import { OrganizationServiceImpl } from '@/services/organization/OrganizationServiceImpl';
import { UsersServiceImpl } from '@/services/users/UsersServiceImpl';
import type { AdminServices } from '@/types/services.types';
import { HttpFetcherService } from '@/services/http/HttpFetcherService';

/**
 * IMPORTANT:
 * If your API_CONFIG.baseURL already includes `/v1/admin/public`,
 * pass an empty basePath ('') here to avoid duplicating the segment.
 */
export const createJsonServices = (): AdminServices => {
  const httpService = new HttpFetcherService();
  const authService = new AuthServiceImpl(httpService);
  const organizationService = new OrganizationServiceImpl(httpService);
  const administratorsService = new AdministratorsServiceImpl(httpService);
  const usersService = new UsersServiceImpl(httpService);

  return { authService, organizationService, administratorsService, usersService };
};
